'use strict';

import { combineReducers } from 'redux';
import update from 'immutability-helper';
import * as types from './types';
import * as llTypes from '@/state/domains/locationList/types';

const getUserFromLS = () => {
	return JSON.parse(localStorage.getItem('user')) || null;
};

const maybeCacheUser = user => {

	const fromLS = getUserFromLS();

	if (user._id === fromLS._id) {
		localStorage.setItem('user', JSON.stringify(user));
	}

	return user;
};

const byUsername = (
    state = {},
    action
) => {

	let user, users, username;

    switch (action.type) {

		case types.SET_LOGGED_IN_USER:

			user = getUserFromLS();

			if (user) {
				return { ...state, [ user.username ]: maybeCacheUser(user) };
			}
			return state;

		case types.GET_USERS_COMPLETED:

			({ users } = action.data);

			if (Array.isArray(users)) {
				const byUsername = users.reduce(
					(byUsername, user) => ({
						...byUsername,
						[ user.username ]: maybeCacheUser(user),
					}),
					{}
				);

				return { ...state, ...byUsername };
			}
			return state;

        case types.FETCH_USER_COMPLETED:

			({ user } = action.data);
			return { ...state, [ user.username ]: maybeCacheUser(user) };

        case types.POST_UPDATE_USER_COMPLETED:

			({ user } = action.data);

			const currentUser = Object.entries(state).find(
				([ username, currentUser ]) => currentUser._id === user._id
			);

			if (currentUser && currentUser[ 1 ].username !== user.username) {
				let { [ currentUser[ 1 ].username ]: old, ...filtered } = state;
				return { ...filtered, [ user.username ]: user };
			}

			return { ...state, [ user.username ]: maybeCacheUser(user) };

		case types.POST_SETTINGS_COMPLETED:

			if ('user' in action.data) {
				({ user } = action.data);
				username = user.username;
				return { ...state, [ username ]: maybeCacheUser(user) };
			}
			return state;

        case types.DELETE_USER_COMPLETED:

			({ user } = action.data);

			const { [ user.username ]: deleted, ...remaining } = state;

			return remaining;
			
        default:
            return state;
    }
};

const usernameById = (
	state = {},
	action
) => {

	let user;

	switch (action.type) {

		case types.GET_USERS_COMPLETED:

			const { users } = action.data;

			if (Array.isArray(users)) {
				const byId = users.reduce(
					(byId, user) => ({
						[ user._id ]: user.username,
					}),
					{}
				);

				return { ...state, ...byId };
			}

			return state;

		case types.SET_LOGGED_IN_USER:

			user = getUserFromLS();

			if (user) {
				return { ...state, [ user._id ]: user.username };
			}
			return state;

		case types.POST_UPDATE_USER_COMPLETED:
        case types.FETCH_USER_COMPLETED:

			({ user } = action.data);

			return { ...state, [ user._id ]: user.username };

        case types.DELETE_USER_COMPLETED:

			({ user } = action.data);

			const { [ user._id ]: deleted, ...remaining } = state;

			return remaining;

		default:
            return state;
	}
};

const allUsernames = (state = [], action) => {

	let user;

    switch (action.type) {

		case types.GET_USERS_COMPLETED:

			const { users } = action.data;

			const usernames = users.map(u => u.username);

			return [ ...new Set([ ...state, ...usernames ]) ];

		case types.SET_LOGGED_IN_USER:

			user = getUserFromLS();

			if (user) {
				return [ ...new Set([ ...state, user.username ]) ];
			}

			return state;

		case types.POST_UPDATE_USER_COMPLETED:
        case types.FETCH_USER_COMPLETED:

			({ user } = action.data);

			return [ ...new Set([ ...state, user.username ]) ];

        case types.DELETE_USER_COMPLETED:

			({ user } = action.data);

			return state.filter(username => username !== user.username);

        default:
            return state;
    }
};

const loggedInUser = (state = null, action) => {

	switch (action.type) {

		case types.LOGIN_SUCCESS:
			return maybeCacheUser(action.data.user);

		default:
			return getUserFromLS();
	}
};

const users = combineReducers({
    byUsername,
	usernameById,
    allUsernames,
	loggedInUser,
});

export default users;
